module.exports = __webpack_public_path__ + "img/arrow_left_p.1a3a28bd.svg";